/** Note actions */
export const NOTE_CREATE = 'NOTE_CREATE';
export const NOTE_DELETE = 'NOTE_DELETE';
export const NOTE_UPDATE = 'NOTE_UPDATE';
export const NOTES_COLLAPSE_NOTE = 'NOTES_COLLAPSE_NOTE';
export const NOTES_EXPAND_NOTE = 'NOTES_EXPAND_NOTE';
export const NOTES_FETCH = 'NOTES_FETCH';
export const NOTES_FETCH_FAILURE = 'NOTES_FETCH_FAILURE';
export const NOTES_FETCH_SUCCESS = 'NOTES_FETCH_SUCCESS';
export const NOTES_SET_SELECTED_NOTE = 'NOTES_SET_SELECTED_NOTE';
/** Notes fetch request status */
export const STATUS_NONE = 'none';
export const STATUS_PENDING = 'pending';
export const STATUS_SUCCESS = 'success';
export const STATUS_ERROR = 'error';
/** Note types */
export const NOTE_WATCHLIST = 'watchlist';
export const NOTE_ALERT = 'alert';
export const NOTE_SECURITY = 'security';
